import React from 'react'
import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifButton,
  MotifErrorMessage,
} from '@ey-xd/motif-react'

import danger from '../../assets/images/danger.svg'

import styles from './DeleteModal.module.scss'

interface DeleteModalProps {
  isVisible: boolean
  setIsVisible: (isVisible: boolean) => void
  handleDelete: () => void
  isMessageVisible: boolean
}

function DeleteModal({
  isVisible,
  setIsVisible,
  handleDelete,
  isMessageVisible,
}: DeleteModalProps) {
  return (
    <MotifModal
      show={isVisible}
      onClose={() => setIsVisible(false)}
      variant="alt"
      danger="true"
    >
      <MotifModalHeader danger="true">
        <img src={danger} alt="danger" />
        <br/>
        Delete client card?
      </MotifModalHeader>
      <MotifModalBody>
        <p>
          Are you sure you want to delete this client card? This action can not
          be undone.
        </p>
        {isMessageVisible ? (
          <MotifErrorMessage>
            Deleting client card, please wait...
          </MotifErrorMessage>
        ) : (
          <></>
        )}
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton
          size="medium"
          variant="secondary"
          type="button"
          onClick={() => setIsVisible(false)}
        >
          Cancel
        </MotifButton>
        <MotifButton size="medium" type="button" onClick={handleDelete} className={styles.dangerButton}>
          Delete
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  )
}

export default DeleteModal
